import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';

export const Footer = () => {
  return (
    <footer className="bg-[#333333] text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
          <span className="text-gray-400">|</span>
          <Link
            href="/contact"
            className="hover:text-[#E31837] transition-colors"
          >
            Contact
          </Link>
          <span className="text-gray-400">|</span>
          <a
            href="/redebins/documents/RED-E-BINS_Privacy_Policy_Final.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#E31837] transition-colors"
          >
            Privacy Notice
          </a>
          <span className="text-gray-400">|</span>
          <a
            href="/redebins/documents/RED-E-BINS_Terms_of_Use_Final.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#E31837] transition-colors"
          >
            Terms Of Use
          </a>
          <span className="text-gray-400">|</span>
        </div>
      </div>
    </footer>
  );
};
